/* Cherry Hill - PDP bundle behavior (Complete Your Set and Save)
   Moved out of sections/ch-pdp-bundle.liquid so the section stays under the write size ceiling.

   SIZE RULE (one master, no memory):
   The buy box is the single source of truth. Any change to the buy box size snaps every
   tile in the set to that size, every time, with no per-tile memory of earlier manual
   picks. A tile shows the master size even when that size is sold out (greyed, not
   addable, marked OUT) so the buyer sees one consistent size across the set and only has
   to act on the exception. If a product does not carry that size at all, the tile falls
   back to its first available size, because showing a size the product never had would be
   a lie. A buyer can still override one tile directly; that override lasts until the next
   buy box change, which resyncs everything.

   OUT PLACEMENT:
   On desktop OUT is written into the size badge itself ("2XL OUT") rather than onto a
   separate line beneath it. Same text run as the size, so it cannot fall out of alignment
   with it. On mobile the badge is hidden and OUT stays on the note line under the chip. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.chsInit === '1') { return; }
    var sid = root.id.slice(4);
    var dataEl = document.getElementById('chs-data-' + sid);
    if (!dataEl) { return; }
    var CFG;
    try { CFG = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.chsInit = '1';

    var DISCOUNT = 0.75;
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-tile]'));
    var btn = root.querySelector('[data-add]');
    var wasEl = root.querySelector('[data-was]');
    var nowEl = root.querySelector('[data-now]');
    var saveEl = root.querySelector('[data-save]');
    tiles.forEach(function (t) { t._cfg = CFG.tiles[+t.dataset.idx] || {}; });
    var anchorTile = null;
    tiles.forEach(function (t) { if (t._cfg.role === 'anchor') { anchorTile = t; } });

    // One buy box per PDP. We read the anchor's selected size and live variant id from it.
    var buybox = document.querySelector('[id^="ch-buybox-"]');
    function anchorSize() {
      if (!buybox) { return null; }
      var on = buybox.querySelector('.ch-bb__sz.on');
      return on ? on.getAttribute('data-val') : null;
    }
    function anchorVariantId() {
      var el = document.querySelector('.ch-bb__form [data-bb-id]') || document.querySelector('[data-bb-id]');
      var v = el ? el.value : '';
      return v || (CFG.anchorDefault || '');
    }
    function anchorAvailable() {
      var a = document.querySelector('.ch-bb__atc');
      return a ? !a.disabled : true;
    }
    function money(cents) { return '$' + (Number(cents) / 100).toFixed(2); }

    // Current size value per tile lives on the tile element.
    function getVal(tile) { return tile.dataset.szv || ''; }
    function setVal(tile, v) {
      tile.dataset.szv = v || '';
      var lab = tile.querySelector('[data-szval]');
      if (lab) { lab.textContent = v || 'Size'; }
      var ind = tile.querySelector('[data-szind]');
      if (ind) { ind.textContent = v || 'Size'; }
      var opts = tile.querySelectorAll('.chs__opt, .chs__pill');
      for (var i = 0; i < opts.length; i++) {
        var onv = v !== '' && opts[i].getAttribute('data-v') === v;
        opts[i].classList.toggle('on', onv);
        opts[i].setAttribute('aria-selected', onv ? 'true' : 'false');
      }
    }
    function hasSizeValue(cfg, size) {
      for (var i = 0; i < cfg.variants.length; i++) {
        if (String(cfg.variants[i].size) === size) { return true; }
      }
      return false;
    }
    function closeMenus() {
      var open = root.querySelectorAll('.chs__szrow.open');
      for (var i = 0; i < open.length; i++) {
        open[i].classList.remove('open');
        var b = open[i].querySelector('[data-size]');
        if (b) { b.setAttribute('aria-expanded', 'false'); }
      }
      var ot = root.querySelectorAll('.chs__tile.sz-open');
      for (var j = 0; j < ot.length; j++) { ot[j].classList.remove('sz-open'); }
    }

    // Apply a picked size to a tile.
    function pick(tile, val) {
      var cfg = tile._cfg;
      if (cfg.role === 'anchor') {
        var moved = false;
        if (buybox && val) {
          var btns = buybox.querySelectorAll('.ch-bb__sz');
          for (var i = 0; i < btns.length; i++) {
            if (btns[i].getAttribute('data-val') === val) { btns[i].click(); moved = true; break; }
          }
        }
        if (!moved) { setVal(tile, anchorSize() || ''); }
        syncAll();
        return;
      }
      setVal(tile, val);
      var cb = tile.querySelector('.chs__cb');
      var r = resolve(tile);
      if (r.available && cb) { cb.disabled = false; cb.checked = true; }
      recompute();
    }

    // Build the size controls once, for every tile whose product has a size option.
    tiles.forEach(function (tile) {
      var cfg = tile._cfg;
      var wrap = tile.querySelector('[data-szwrap]');
      var trig = tile.querySelector('[data-size]');
      var menu = tile.querySelector('[data-szmenu]');
      var pills = tile.querySelector('[data-szpills]');
      if (!wrap || !trig || !menu) { return; }
      if (!cfg.hasSize) { wrap.style.visibility = 'hidden'; return; }
      var mh = '';
      var ph = '';
      for (var i = 0; i < cfg.variants.length; i++) {
        var v = cfg.variants[i];
        var s = String(v.size);
        var sv = s.replace(/"/g, '&quot;');
        var dis = v.available ? '' : ' disabled';
        mh += '<button type="button" class="chs__opt" role="option" aria-selected="false" data-v="' + sv + '"' + dis + '>' + s + '</button>';
        ph += '<button type="button" class="chs__pill" role="option" aria-selected="false" data-v="' + sv + '"' + dis + '>' + s + '</button>';
      }
      menu.innerHTML = mh;
      if (pills) { pills.innerHTML = ph; }
      function handlePick(e) {
        var opt = e.target && e.target.closest ? e.target.closest('[data-v]') : null;
        if (!opt || opt.disabled) { return; }
        e.preventDefault();
        var val = opt.getAttribute('data-v') || '';
        closeMenus();
        pick(tile, val);
      }
      trig.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = wrap.classList.contains('open');
        closeMenus();
        if (!isOpen) {
          wrap.classList.add('open');
          trig.setAttribute('aria-expanded', 'true');
          tile.classList.add('sz-open');
        }
      });
      menu.addEventListener('click', function (e) { handlePick(e); trig.focus(); });
      if (pills) { pills.addEventListener('click', handlePick); }
    });

    // The anchor control is a remote control for the buy box. Without a buy box it cannot
    // drive anything, so hide it and fall back to the default variant.
    if (anchorTile && !buybox) {
      var arow = anchorTile.querySelector('[data-szwrap]');
      if (arow) { arow.style.visibility = 'hidden'; }
    }

    // Snap every tile to the buy box size. No per-tile memory: the master always wins.
    function syncAll() {
      var size = anchorSize();
      tiles.forEach(function (tile) {
        var cfg = tile._cfg;
        if (!cfg.hasSize) { return; }
        if (size != null && hasSizeValue(cfg, size)) {
          setVal(tile, size);
          return;
        }
        // Product does not carry this size at all. Fall back to its first available size
        // rather than displaying a size the product never had.
        var fallback = '';
        for (var i = 0; i < cfg.variants.length; i++) {
          if (cfg.variants[i].available) { fallback = String(cfg.variants[i].size); break; }
        }
        setVal(tile, fallback);
      });
      recompute();
    }

    // Resolve the addable variant for a tile. The anchor follows the buy box; companions
    // follow their own visible control.
    function resolve(tile) {
      var cfg = tile._cfg;
      if (cfg.role === 'anchor') {
        var id = anchorVariantId();
        return { id: id ? Number(id) : null, available: !!id && anchorAvailable(), offered: true };
      }
      if (!cfg.hasSize) {
        for (var i = 0; i < cfg.variants.length; i++) {
          if (cfg.variants[i].available) { return { id: cfg.variants[i].id, available: true, offered: true }; }
        }
        return { id: null, available: false, offered: true };
      }
      var val = getVal(tile);
      if (!val) { return { id: null, available: false, offered: false }; }
      for (var j = 0; j < cfg.variants.length; j++) {
        if (String(cfg.variants[j].size) === val) {
          return { id: cfg.variants[j].id, available: !!cfg.variants[j].available, offered: true };
        }
      }
      return { id: null, available: false, offered: false };
    }

    var isAdding = false;

    function recompute() {
      var chosen = [];
      tiles.forEach(function (tile) {
        var cfg = tile._cfg;
        var r = resolve(tile);
        var cb = tile.querySelector('.chs__cb');
        var note = tile.querySelector('[data-note]');
        var ind = tile.querySelector('[data-szind]');
        var val = getVal(tile);
        if (!r.available) {
          cb.checked = false; cb.disabled = true;
          tile.classList.remove('is-on'); tile.classList.add('is-na');
          // Desktop badge carries OUT in the same text run as the size.
          if (ind) { ind.textContent = val ? (val + ' OUT') : 'OUT'; }
          if (note) { note.textContent = 'OUT'; }
        } else {
          cb.disabled = false;
          tile.classList.remove('is-na');
          if (ind) { ind.textContent = val || 'Size'; }
          if (note) { note.textContent = ''; }
          tile.classList.toggle('is-on', cb.checked);
          tile.classList.toggle('is-off', !cb.checked);
          if (cb.checked) { chosen.push({ id: r.id, price: cfg.price }); }
        }
      });

      var count = chosen.length;
      var was = 0; chosen.forEach(function (c) { was += Number(c.price); });
      if (count >= 2) {
        var now = Math.round(was * DISCOUNT);
        wasEl.textContent = money(was); wasEl.style.display = '';
        nowEl.textContent = money(now);
        if (saveEl) { saveEl.textContent = 'Save ' + money(was - now); saveEl.hidden = false; }
      } else if (count === 1) {
        wasEl.textContent = ''; wasEl.style.display = 'none';
        nowEl.textContent = money(was);
        if (saveEl) { saveEl.hidden = true; }
      } else {
        wasEl.textContent = ''; wasEl.style.display = 'none'; nowEl.textContent = '';
        if (saveEl) { saveEl.hidden = true; }
      }
      btn.disabled = count < 1 || isAdding;
      btn._items = chosen.map(function (c) { return { id: c.id, quantity: 1 }; });
    }

    tiles.forEach(function (tile) {
      var cb = tile.querySelector('.chs__cb');
      cb.addEventListener('change', recompute);
      // The tile is a label wired to the checkbox. Taps on the size row must not toggle it.
      tile.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.chs__szrow')) { e.preventDefault(); }
      });
    });

    // Close open size menus on outside taps and on Escape.
    document.addEventListener('pointerdown', function (e) {
      var inRow = e.target && e.target.closest ? e.target.closest('.chs__szrow') : null;
      if (!inRow) { closeMenus(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeMenus(); }
    });

    function addSet() {
      if (isAdding) { return; }
      var items = (btn._items || []).filter(function (it) { return it.id; });
      if (!items.length) { return; }
      isAdding = true; btn.disabled = true;
      var orig = btn.textContent; btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) { throw new Error('add failed ' + r.status); } return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { isAdding = false; btn.textContent = orig; recompute(); });
    }
    btn.addEventListener('click', function (e) { e.preventDefault(); addSet(); });

    // Any buy box size change resyncs the whole set. Class toggles on the size buttons
    // drive this, including programmatic changes made by the anchor tile's own control.
    if (buybox && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { syncAll(); });
      mo.observe(buybox, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    syncAll();
  }

  function initAll() {
    var roots = document.querySelectorAll('.chs[id^="chs-"]');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () { initAll(); });
})();
